import React from 'react';
import { bool, func } from 'prop-types';

import { gvaAddNewButton } from 'services/FeatureFlags';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import PreferencesSection from 'components/layouts/Preferences/shared/PreferencesSection';
import BeaconCustomerAccountList from './CustomerAccountList/BeaconCustomerAccountList';
import CustomerAccountList from './CustomerAccountList/CustomerAccountList';

const isGVABeaconAccountListEnabled = gvaAddNewButton();;

const SummaryView = ({
  clearActiveCustomer,
  deleteCustomer,
  isActive,
  hasActive,
  setActiveCustomer,
  activeCustomerIndex,
  ...viewRelationship
}) => (
  <PreferencesSection className="grant-view-access" fullBackground>
    <PreferencesRow className="document-delivery-preferences-row">
      <div className="gva-main-content">
        {isGVABeaconAccountListEnabled ? (
          <BeaconCustomerAccountList
            clearActiveCustomer={clearActiveCustomer}
            deleteCustomer={deleteCustomer}
            isActive={isActive}
            hasActive={hasActive}
            setActiveCustomer={setActiveCustomer}
            activeCustomerIndex={activeCustomerIndex}
            {...viewRelationship}
          />
        ) : (
          <CustomerAccountList
            clearActiveCustomer={clearActiveCustomer}
            deleteCustomer={deleteCustomer}
            isActive={isActive}
            hasActive={hasActive}
            setActiveCustomer={setActiveCustomer}
            {...viewRelationship}
          />
        )}
      </div>
    </PreferencesRow>
  </PreferencesSection>
);

SummaryView.propTypes = {
  clearActiveCustomer: func.isRequired,
  deleteCustomer: func.isRequired,
  isActive: bool.isRequired,
  hasActive: bool.isRequired,
  setActiveCustomer: func.isRequired
};

export default SummaryView;
